import $ from '../$';
import each from '../functions/each';
import { cssNumber, getStyle, isElement, isFunction, isNull, isNumber, isObjectLike, isUndefined, toCamelCase } from '../utils';
import './each';
each(['attr', 'prop', 'css'], (nameIndex, name) => {
  function set(element, key, value) {
    // 值为 undefined 时，不修改
    if (isUndefined(value)) {
      return;
    }
    switch (nameIndex) {
      // attr
      case 0:
        if (isNull(value)) {
          element.removeAttribute(key);
        } else {
          element.setAttribute(key, value);
        }
        break;
      // prop
      case 1:
        // @ts-ignore
        element[key] = value;
        break;
      // css
      default:
        key = toCamelCase(key);
        // @ts-ignore
        element.style[key] = isNumber(value) ? `${value}${cssNumber.indexOf(key) > -1 ? '' : 'px'}` : value;
        break;
    }
  }
  function get(element, key) {
    switch (nameIndex) {
      // attr
      case 0:
        // 属性不存在时，原生 getAttribute 方法返回 null，而 jquery 返回 undefined。这里和 jquery 保持一致
        const value = element.getAttribute(key);
        return isNull(value) ? undefined : value;
      // prop
      case 1:
        // @ts-ignore
        return element[key];
      // css
      default:
        return getStyle(element, key);
    }
  }
  $.fn[name] = function (key, value) {
    if (isObjectLike(key)) {
      each(key, (k, v) => {
        // @ts-ignore
        this[name](k, v);
      });
      return this;
    }
    if (arguments.length === 1) {
      const element = this[0];
      return isElement(element) ? get(element, key) : undefined;
    }
    return this.each((i, element) => {
      set(element, key, isFunction(value) ? value.call(element, i, get(element, key)) : value);
    });
  };
});